import React from 'react';
import './CharacterUsageBar.scss';

const CharacterUsageBar = ({ totalCharacters, characterLimit, extraCredits, isLoading = false }) => {
  const usagePercentage = Math.min((totalCharacters / characterLimit) * 100, 100);
  const hasExtraCredits = extraCredits > 0;
  
  const formatNumber = (num) => {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + 'M';
    } else if (num >= 1000) {
      return (num / 1000).toFixed(1) + 'K';
    }
    return num.toLocaleString();
  };

  if (isLoading) {
    return (
      <div className="character-usage-bar">
        <div className="character-usage-header">
          <span className="character-usage-title">Character Usage</span>
          <div className="character-usage-loading">
            <div className="loading-dots">
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
            </div>
          </div>
        </div>
        <div className="character-usage-progress">
          <div className="progress-bar">
            <div className="progress-fill loading"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="character-usage-bar">
      <div className="character-usage-header">
        <span className="character-usage-title">Character Usage</span>
        <div className="character-usage-stats">
          <span className="characters-used">{formatNumber(totalCharacters)}</span>
          <span className="separator">/</span>
          <span className="character-limit">{formatNumber(characterLimit)}</span>
          {hasExtraCredits && (
            <span className="extra-credits-indicator">
              +{formatNumber(extraCredits)}
            </span>
          )}
        </div>
      </div>
      
      <div className="character-usage-progress">
        <div className="progress-bar">
          <div 
            className="progress-fill"
            style={{ width: `${usagePercentage}%` }}
          />
          {hasExtraCredits && (
            <div className="extra-credits-bar">
              <div className="extra-credits-fill" />
            </div>
          )}
        </div>
        
        <div className="progress-labels">
          <span className="used-label">Used</span>
          <span className="limit-label">Limit</span>
          {hasExtraCredits && (
            <span className="extra-label">Extra</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default CharacterUsageBar; 